"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datePicker = _interopRequireDefault(require("@alifd/next/lib/date-picker"));

var _moment = _interopRequireDefault(require("moment"));

function ownKeys(object, enumerableOnly) {
  var keys = (0, _keys["default"])(object);

  if (_getOwnPropertySymbols["default"]) {
    var symbols = (0, _getOwnPropertySymbols["default"])(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty3["default"])(target, key, source[key]);
      });
    } else if (_getOwnPropertyDescriptors["default"]) {
      (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key));
      });
    }
  }

  return target;
}
/**
 * Compatible `locale` to moment's locale format
 * moment's doesn't recognize regionless chinese locale like `zh`
 * @param {String} locale
 */


var fixLocale = function fixLocale(locale) {
  return locale === 'zh' ? 'zh-cn' : locale;
};
/**
 * Give `format` prop a default value, based on current locale.
 */


var withIntlFormat = function withIntlFormat(WrappedComponent) {
  var _class, _temp;

  return (// eslint-disable-next-line react/prefer-stateless-function
    _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      (0, _inherits2["default"])(H, _Component);

      function H() {
        (0, _classCallCheck2["default"])(this, H);
        return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(H).apply(this, arguments));
      }

      (0, _createClass2["default"])(H, [{
        key: "render",
        // Access context temporary
        // TODO: Will be refactor with PR
        value: function render() {
          var _this$props = this.props,
              format = _this$props.format,
              restProps = (0, _objectWithoutProperties2["default"])(_this$props, ["format"]); // Access context temporary
          // TODO: Will be refactor with PR

          var _this$context$nextLoc = this.context.nextLocale;
          _this$context$nextLoc = _this$context$nextLoc === void 0 ? {} : _this$context$nextLoc;
          var momentLocale = _this$context$nextLoc.momentLocale; // dummy momentInstance to normalize locale string

          var momentInstance = (0, _moment["default"])();
          var currentLocale = momentInstance.locale(fixLocale(momentLocale) || 'en'); // if value is a moment instance already, get locale from it

          var value = restProps.value,
              defaultValue = restProps.defaultValue;
          var exactValue = value || defaultValue;

          if (_moment["default"].isMoment(exactValue)) {
            currentLocale = exactValue.locale();
          }

          var defaultFormat = _moment["default"].localeData(currentLocale).longDateFormat('ll');

          var exactFormat = typeof format !== 'undefined' ? format : defaultFormat;

          var props = _objectSpread({}, restProps, {
            format: exactFormat
          });

          return _react["default"].createElement(WrappedComponent, props);
        }
      }]);
      return H;
    }(_react.Component), (0, _defineProperty3["default"])(_class, "displayName", "withIntlFormat(".concat(WrappedComponent.displayName, ")")), (0, _defineProperty3["default"])(_class, "propTypes", {
      format: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string, _propTypes["default"].object])
    }), (0, _defineProperty3["default"])(_class, "contextTypes", {
      nextLocale: _propTypes["default"].objectOf(_propTypes["default"].any)
    }), _temp
  );
};

var RangePicker = _datePicker["default"].RangePicker,
    MonthPicker = _datePicker["default"].MonthPicker,
    YearPicker = _datePicker["default"].YearPicker;
var WrappedDatePicker = withIntlFormat(_datePicker["default"]);
WrappedDatePicker.RangePicker = withIntlFormat(RangePicker);
WrappedDatePicker.MonthPicker = withIntlFormat(MonthPicker);
WrappedDatePicker.YearPicker = withIntlFormat(YearPicker);
var _default = WrappedDatePicker;
exports["default"] = _default;